/** 是否显示 */
const show = true

/**
 * 是否显示关键词内容
 * @param {string} str 关键词内容
 * @returns 是否显示
 */
export const showKey = (str) => {
    if (!str) {
        return show
    } else {
        return show ? str : ''
    }
}

/**
 * 标题处理
 * @param {string} title 项目标题
 */
export const handleTitle = (title) => {
    document.title = show ? title : '测试'
}